module.exports = __webpack_public_path__ + "img/icon_gas_un.ad3e3b0f.png";